import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Home, Users, Briefcase, FileText, BarChart3, Calendar, Settings, LogOut, ChevronDown } from 'lucide-react';

const DashboardDemo = () => {
  const { i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState('home');

  const isEN = i18n.language?.startsWith('en');
  const img = (base) => isEN ? `/${base}-en.png` : `/${base}.png`;

  const menuItems = [
    { id: 'home',      name: isEN ? 'Home'         : 'Ana Sayfa',  icon: Home,     image: img('anasayfa') },
    { id: 'appoint',   name: isEN ? 'Appointments' : 'Randevular', icon: Calendar,  image: img('randevular'), isNew: true },
    { id: 'customers', name: isEN ? 'Customers'    : 'Müşteriler', icon: Users,     image: img('musteriler') },
    { id: 'employees', name: isEN ? 'Employees'    : 'Çalışanlar', icon: Briefcase, image: img('calisanlar') },
    { id: 'services',  name: isEN ? 'Services'     : 'Hizmetler',  icon: FileText,  image: img('islemler') },
    { id: 'analytics', name: isEN ? 'Analytics'    : 'Analitik',   icon: BarChart3, image: img('raporlar'),  hasDropdown: true },
    { id: 'settings',  name: isEN ? 'Settings'     : 'Ayarlar',    icon: Settings,  image: img('ozellestirme'), hasDropdown: true },
  ];

  const handleTabChange = (id) => {
    setActiveTab(id);
  };

const renderContent = () => {
    const currentItem = menuItems.find(item => item.id === activeTab);

    if (!currentItem || !currentItem.image) {
      return (
        <div className="p-6 bg-white rounded-b-lg shadow">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">{activeTab}</h2>
          <p className="text-gray-600">
            Resim bulunamadı.
          </p>
        </div>
      );
    }

    return (
      // DEĞİŞİKLİK 1: Kapsayıcı div'den padding (p-6) ve flex özellikleri kaldırıldı.
      <div className="bg-white rounded-b-lg shadow">
        <img 
          src={currentItem.image} 
          alt={activeTab} 
          // DEĞİŞİKLİK 2: Görselin tam genişlikte olması ve alt köşelerinin yuvarlatılması sağlandı.
          className="w-full h-auto rounded-b-lg" 
        />
      </div>
    );
  };

  return (
    <div>
      {/* Navigation Bar — matches Navigation.js */}
      <div className="bg-gradient-to-r from-cyan-500 to-blue-500 pb-1">
        <div className="bg-white">
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex items-center justify-between h-16">
              {/* Logo */}
              <div className="flex-shrink-0 flex items-center gap-2">
                <span className="text-xl font-bold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent">
                  Adisyon Takip
                </span>
              </div>

              {/* Nav items */}
              <div className="flex items-center space-x-1">
                {menuItems.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => handleTabChange(item.id)}
                    className={`px-3 py-2 text-sm font-medium rounded-md transition-all duration-300 flex items-center space-x-1 relative
                    ${activeTab === item.id
                      ? 'text-blue-600 bg-blue-50'
                      : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
                    }`}
                  >
                    <item.icon className="h-4 w-4" />
                    <span className="whitespace-nowrap">{item.name}</span>
                    {item.hasDropdown && (
                      <ChevronDown className="h-3.5 w-3.5 opacity-60" />
                    )}
                    {item.isNew && (
                      <span className="absolute -top-1 -right-1 flex h-3 w-3">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" />
                        <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-500" />
                      </span>
                    )}
                  </button>
                ))}
              </div>

              {/* Logout */}
              <button className="flex items-center px-3 py-2 text-sm font-medium text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-md transition-all duration-300">
                <LogOut className="h-4 w-4 mr-1" />
                <span>{isEN ? 'Sign Out' : 'Çıkış Yap'}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Content Area */}
      {renderContent()}
    </div>
  );
};

export default DashboardDemo;